import { Ban, ExternalLink, AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface StoreSuspendedProps {
  storeName?: string;
  suspensionReason?: string;
  scheduledDeletionAt?: string;
}

export function StoreSuspended({ storeName, scheduledDeletionAt }: StoreSuspendedProps) {
  const getDashboardUrl = () => {
    const currentHost = window.location.host;
    if (currentHost.includes('localhost') || currentHost.includes('127.0.0.1')) {
      return 'http://localhost:3001/dashboard';
    }
    return 'https://hystore.com.br/dashboard';
  };

  const daysUntilDeletion = scheduledDeletionAt
    ? Math.max(0, Math.ceil((new Date(scheduledDeletionAt).getTime() - Date.now()) / 86_400_000))
    : null;

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="w-20 h-20 rounded-full bg-destructive/10 flex items-center justify-center mx-auto">
          <Ban className="w-10 h-10 text-destructive" />
        </div>

        <div className="space-y-2">
          <h1 className="font-display text-3xl font-bold text-foreground">
            Loja Suspensa
          </h1>
          <p className="text-muted-foreground font-medium">
            Por Falta de Pagamento
          </p>
        </div>

        <div className="space-y-3">
          <p className="text-sm text-foreground">
            {storeName
              ? `A loja "${storeName}" está temporariamente suspensa.`
              : 'Esta loja está temporariamente suspensa.'}
          </p>
          <p className="text-sm text-muted-foreground">
            O proprietário precisa regularizar a assinatura para reativá-la.
          </p>
        </div>

        {daysUntilDeletion !== null && (
          <div className="rounded-lg border border-destructive/30 bg-destructive/5 p-3 flex items-start gap-2 text-left">
            <AlertTriangle className="w-4 h-4 text-destructive shrink-0 mt-0.5" />
            <p className="text-xs text-destructive">
              {daysUntilDeletion === 0
                ? 'Esta loja pode ser excluída permanentemente a qualquer momento.'
                : `Esta loja será excluída permanentemente em ${daysUntilDeletion} dia${daysUntilDeletion !== 1 ? 's' : ''} caso não seja regularizada.`}
            </p>
          </div>
        )}

        <div className="pt-2">
          <Button
            onClick={() => { window.location.href = getDashboardUrl(); }}
            variant="default"
            className="gap-2"
          >
            <ExternalLink className="w-4 h-4" />
            Acessar Dashboard
          </Button>
        </div>

        <div className="pt-4 border-t border-border">
          <p className="text-xs text-muted-foreground">
            Se você acredita que isso é um erro, entre em contato com o suporte.
          </p>
        </div>
      </div>
    </div>
  );
}
